import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  OverlayTrigger,
  Tooltip,
  Table,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
// import ReactExport from "react-export-excel";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";

import messages from "../../../redux/messages";
import SidebarEvaluacionDesempenio from "../../../components/evaluacion_desempenio/SidebarEvaluacionDesempenio";
import {
  copyFactorTemplate,
  deleteFactorTemplate,
  editFactorTemplate,
  getFactorTemplate,
  resetFactorTemplate,
  saveFactorTemplate,
} from "../../../redux/evaluacion_desempenio/FactorTemplate/actions";
import { getPeriodicityByOrg } from "../../../redux/evaluacion_desempenio/Periodicity/actions";
import { getOrgs } from "../../../redux/organization/actions";
import { getClassification } from "../../../redux/Classification/actions";
import Multiselect from "../../../components/MultiselectFormik";

const FactorTemplate = (props) => {
  const fecha = new Date();
  var currentYear = fecha.getFullYear();

  const filters = [
    { id: "nombre", desc: "Plantilla" },
    { id: "clasificacion_id", desc: "Clasificación" },
    { id: "periodicidad_fecha_fin", desc: "Fecha de cierre" },
    // { id: "fecha_solicitud", desc: "Fecha creación" },
  ];

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showModalCopy, setShowModalCopy] = useState(false);
  const [filter, setFilter] = useState("");
  const [_empresa, setEmpresa] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [isOrgSelect, setIsOrgSelect] = useState(false);
  const [_clasi, setClasi] = useState([]);
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre",
    desc: "Plantilla",
  });

  const dispatch = useDispatch();
  const history = useHistory();

  const schema = Yup.object().shape({
    nombre: Yup.string().required("**Campo requerido"),
    clasificacion: Yup.string().required("**Campo requerido"),
    empresa: Yup.string().required("**Campo requerido"),
  });

  const schemaCopy = Yup.object().shape({
    clasificacion: Yup.array().test({
      message: "**Campo requerido",
      test: (val) => val.length !== 0,
    }),
  });

  const {
    loading,
    saveLoading,
    factorTemplatesLength,
    factorTemplates,
    factorTemplatesAll,
    factorTemplateError,
    formError,
    formCopyError,
  } = useSelector((store) => store.factorTemplate);
  const pages = Math.ceil(factorTemplatesLength / limit);

  const {
    loading: loadingPeriodicity,
    periodicity,
    periodicityError,
  } = useSelector((store) => store.periodicity);

  const data = useSelector((store) => store.orgs.orgs);
  const loadingOrgs = useSelector((store) => store.orgs.loading);

  const dataClasificacion = useSelector(
    (store) => store.classification.classification
  );
  const loadingClasificacion = useSelector(
    (store) => store.classification.loading
  );

  var listClasificacion = [];

  dataClasificacion
    .sort((a, b) => (a.nombre > b.nombre ? 1 : b.nombre > a.nombre ? -1 : 0))
    .map((item) => {
      listClasificacion = [
        ...listClasificacion,
        { value: item.id, label: item.nombre.toUpperCase() },
      ];
    });

  const columns = [
    {
      Header: "Empresa",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.periodicidad
            ? value.row.original.list_periodicidad[0].list_empresa[0].nombre
            : ""}
        </div>
      ),
    },
    {
      Header: "Plantilla",
      accessor: "nombre",
      Filter: "",
    },
    {
      Header: "Clasificación",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.periodicidad &&
          value.row.original.list_periodicidad[0].clasificacion
            ? value.row.original.list_periodicidad[0].list_clasificacion[0]
                .nombre
            : "Sin clasificación"}
        </div>
      ),
    },
    {
      Header: "Fecha de cierre",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.periodicidad
            ? moment(value.row.original.list_periodicidad[0].fecha_fin).format(
                "DD/MM/YYYY"
              )
            : ""}
        </div>
      ),
    },
    {
      Header: "Fecha creación",
      accessor: "periodicidad_fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.periodicidad_fecha_creacion).format(
            "DD/MM/YYYY"
          )}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Editar solicitud</Tooltip>}
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              onClick={() => onEdit(value.row.original, value.row.index)}
            >
              <i className="material-icons">edit</i>
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Eliminar plantilla</Tooltip>}
          >
            <Button
              size="sm"
              className="text-danger"
              variant="link"
              type="button"
              onClick={() => onDelete(value.row.original.id, value.row.index)}
            >
              <i className="material-icons">close</i>
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Copiar plantilla</Tooltip>}
          >
            <Button
              size="sm"
              className="text-primary"
              variant="link"
              type="button"
              onClick={() => onCopy(value.row.original, value.row.index)}
            >
              <i className="material-icons">content_copy</i>
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="auto"
            overlay={
              <Tooltip {...props}>Ir al preguntas de evaluación</Tooltip>
            }
          >
            <Button
              size="sm"
              className="text-info"
              variant="link"
              type="button"
              onClick={() =>
                history.push(
                  `/evaluacion-desempenio/admin/preguntas-por-factor/${value.row.original.id}/${value.row.original.periodicidad}`
                )
              }
            >
              <i className="material-icons">double_arrow</i>
            </Button>
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  // Métodos
  const _getFactorTemplate = (
    offs = offset,
    lim = limit,
    filt = filter,
    emp = _empresa
  ) =>
    dispatch(
      getFactorTemplate({
        offset: offs,
        limit: lim,
        tipo_busqueda_2: tipoBusqueda.id,
        filter_2:
          tipoBusqueda.id === "periodicidad_fecha_fin"
            ? filt !== ""
              ? !isNaN(filt)
                ? filt
                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                    8
                  )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                    4
                  )}-${filt.charAt(0)}${filt.charAt(1)}`
              : filt
            : tipoBusqueda.id === "clasificacion_id"
            ? dataClasificacion.find(
                (cl) => cl.nombre.toLowerCase() === filt.toLowerCase()
              )
              ? dataClasificacion.find(
                  (cl) => cl.nombre.toLowerCase() === filt.toLowerCase()
                ).id
              : filt
            : filt,
        tipo_busqueda: "periodicidad_empresa_id",
        filter: emp !== "" ? parseInt(emp) : "",
      })
    );

  useEffect(() => {
    // _getFactorTemplate();
    // dispatch(getPeriodicityByOrg({}));
    setEmpresa("");
    dispatch(resetFactorTemplate());
    dispatch(getOrgs(parseInt(2)));
    dispatch(getClassification({}, 2));
  }, []);

  const onAdd = () => {
    setIsOrgSelect(false);
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    if (item.periodicidad) {
      setIsOrgSelect(true);
      dispatch(
        getPeriodicityByOrg({
          tipo_busqueda: "empresa__id",
          filter: parseInt(item.list_periodicidad[0].empresa),
        })
      );
    }
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getFactorTemplate(oOffset, limit, e.target.filter.value);
  };

  const onCopy = (item, _index) => {
    setEditItem(item);
    setIndex(_index);
    setShowModalCopy(true);
  };

  const onSubmitCopy = (req) => {
    let clasificacion_list = [];
    req.clasificacion.map((item) => {
      clasificacion_list.push(item.value);
    });
    if (window.confirm(messages.copyRequest)) {
      dispatch(
        copyFactorTemplate({
          id: editItem.id,
          clasificacion_list: clasificacion_list,
        },setShowModalCopy)
      );
    }
  };

  const onSubmit = async (req) => {
    const exist = factorTemplates
      .filter((e) => e.fecha_fin === periodicity.fecha_fin)
      .find((e) => e.nombre === req.nombre);
    if (!edit && exist) {
      toastr.info(
        "La plantilla ya existe para el periodo de evaluación actual."
      );
      return;
    }
    if (edit && exist && exist.id !== editItem.id) {
      toastr.info(
        "La plantilla ya existe para el periodo de evaluación actual."
      );
      return;
    }
    const _req = {
      nombre: req.nombre,
      // empresa: req.empresa,
      // periodicidad: edit ? editItem.periodicidad : periodicity.id,
    };
    if (!edit) {
      _req.periodicidad = periodicity.id;
      dispatch(saveFactorTemplate(_req, setShowModal));
    } else {
      dispatch(
        editFactorTemplate(_req, editItem.id, index, setShowModal, offset)
      );
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getFactorTemplate(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteFactorTemplate(id, index, offset));
      window.alert("Se borro este archivo");
    }
  };

  const exists = (value) => {
    return !factorTemplatesAll.find(
      (f) => f.clasificacion === value.value
    );
    // &&f.list_periodicidad[0].anio === currentYear
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarEvaluacionDesempenio show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 px-2 d-flex flex-wrap justify-content-between align-items-center">
            <Row className="justify-content-end align-items-center flex-nowrap">
              <h6 className="font-weight-bold text-uppercase">
                Plantilla de preguntas por factor
              </h6>
            </Row>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    {/* <OverlayTrigger
                      placement="auto"
                      overlay={<Tooltip {...props}>Agregar solicitud</Tooltip>}
                    > */}
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    {/* </OverlayTrigger> */}
                    <Dropdown className="mx-1">
                      <Dropdown.Toggle
                        variant="light"
                        className="btn-sm font rounded-pill"
                      >
                        <i className="material-icons">filter_list</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {filters.map((item) => (
                          <Dropdown.Item
                            onClick={() => setTipoBusqueda(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          <div className="px-2">
            <hr />
          </div>
          <Form.Group as={Col} md={5} className="mb-md-1">
            <Row>
              <Form.Label column sm={3}>
                Empresa
              </Form.Label>
              <Col sm={9}>
                <Row className="d-flex flex-wrap justify-content-start align-items-center">
                  <Col sm={loadingOrgs ? "10" : "12"}>
                    <Form.Control
                      as="select"
                      id="empresa"
                      name="empresa"
                      className="col rounded-pill"
                      defaultValue=""
                      disabled={loadingOrgs}
                      onChange={(e) => {
                        e.preventDefault();
                        setEmpresa(e.currentTarget.value);
                        _getFactorTemplate(
                          offset,
                          limit,
                          filter,
                          e.currentTarget.value
                        );
                      }}
                    >
                      <option className="text-muted" value="" selected disabled>
                        Selecionar Empresa
                      </option>
                      {data.length > 0 &&
                        data.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.nombre}
                          </option>
                        ))}
                    </Form.Control>
                  </Col>
                  {loadingOrgs ? (
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  ) : null}
                </Row>
              </Col>
            </Row>
          </Form.Group>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            factorTemplatesLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={factorTemplates} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={factorTemplatesLength}
                  pages={pages}
                  pagFunc={_getFactorTemplate}
                />
              </>
            )
          )}
          {!loading &&
            !loadingPeriodicity &&
            factorTemplatesLength === 0 &&
            factorTemplateError === "" &&
            _empresa !== "" && (
              <Alert variant="info" className="my-4">
                Aún no hay registros, comience agregando algunos
              </Alert>
            )}
          {!loading &&
            !loadingPeriodicity &&
            factorTemplatesLength === 0 &&
            factorTemplateError === "" &&
            _empresa === "" && (
              <Alert variant="info" className="my-4">
                Aún no ha seleccionado una empresa, seleccione una para ver sus
                plantillas.
              </Alert>
            )}
          {!!factorTemplateError && (
            <Alert variant="danger" className="mt-4 mb-1">
              {factorTemplateError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            nombre: edit ? editItem.nombre : "",
            clasificacion: edit
              ? editItem.list_periodicidad[0].clasificacion
              : "",
            empresa: edit ? editItem.list_periodicidad[0].empresa : _empresa,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit
                    ? "Editar plantilla de preguntas"
                    : "Crear plantilla de preguntas"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-1 mb-2">
                    {formError}
                  </Alert>
                )}
                {!loadingPeriodicity &&
                  !edit &&
                  periodicityError === "" &&
                  !periodicity.id &&
                  isOrgSelect &&
                  !formError && (
                    <Alert variant="danger" className="mt-1 mb-3">
                      El periodo de evaluación ya cerro o no se ha definido,
                      para mas información comunicarse con el administrador.
                    </Alert>
                  )}
                {!loadingPeriodicity &&
                  !edit &&
                  periodicityError === "" &&
                  periodicity.id &&
                  isOrgSelect &&
                  !formError && (
                    <Alert variant="info" className="mt-1 mb-3">
                      Si el periodo de evaluación ya esta siendo utilizado no
                      podra eliminar el registro.
                    </Alert>
                  )}
                {edit && moment(fecha) > moment(editItem.fecha_fin) && (
                  <Alert variant="danger" className="mt-1 mb-3">
                    La plantilla ya ha cerrado.
                  </Alert>
                )}
                {!!periodicityError && !formError && (
                  <Alert variant="danger" className="mt-1 mb-3">
                    {periodicityError}
                  </Alert>
                )}
                {_empresa === "" && !edit && !formError && (
                  <Alert variant="info" className="mt-1 mb-3">
                    Debe seleccionar una empresa previamente.
                  </Alert>
                )}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Nombre de la plantilla
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col>
                        <Form.Control
                          id="nombre"
                          name="nombre"
                          isInvalid={touched.nombre && errors.nombre}
                          isValid={touched.nombre && !errors.nombre}
                          onBlur={handleBlur("nombre")}
                          onChange={handleChange}
                          value={values.nombre}
                          className="rounded-pill"
                          type="text"
                          placeholder=""
                          disabled={
                            (!edit && _empresa === "") ||
                            (edit && moment(fecha) > moment(editItem.fecha_fin))
                          }
                        ></Form.Control>
                      </Col>
                    </Row>
                    {touched.nombre && errors.nombre && (
                      <Col>
                        <small className="text-danger">{errors.nombre}</small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Empresa
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loadingOrgs ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="empresa"
                          name="empresa"
                          className="col rounded-pill"
                          isInvalid={touched.empresa && errors.empresa}
                          isValid={touched.empresa && !errors.empresa}
                          onBlur={handleBlur("empresa")}
                          value={values.empresa}
                          // defaultValue={empresa}
                          // disabled={loadingOrgs || loadingPeriodicity || edit}
                          disabled
                          // onChange={(e) => {
                          //   dispatch(
                          //     getPeriodicityByOrg({
                          //       tipo_busqueda: "empresa__id",
                          //       filter: parseInt(e.currentTarget.value),
                          //       tipo_busqueda_2: "anio",
                          //       filter_2: parseInt(n),
                          //     })
                          //   );
                          //   if (e.currentTarget.value !== "") {
                          //     setIsOrgSelect(true);
                          //   } else {
                          //     setIsOrgSelect(false);
                          //   }
                          //   handleChange(e);
                          // }}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar Empresa
                          </option>
                          {data.length > 0 &&
                            data.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.nombre}
                              </option>
                            ))}
                        </Form.Control>
                      </Col>
                      {loadingOrgs ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                    {touched.empresa && errors.empresa && (
                      <Col>
                        <small className="text-danger">{errors.empresa}</small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Clasificación
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col
                        sm={
                          loadingClasificacion || loadingPeriodicity
                            ? "10"
                            : "12"
                        }
                      >
                        <Form.Control
                          as="select"
                          id="clasificacion"
                          name="clasificacion"
                          className="col rounded-pill"
                          isInvalid={
                            touched.clasificacion && errors.clasificacion
                          }
                          isValid={
                            touched.clasificacion && !errors.clasificacion
                          }
                          // onBlur={handleBlur("clasificacion")}
                          value={values.clasificacion}
                          // defaultValue={clasificacion}
                          onChange={(e) => {
                            e.preventDefault();
                            dispatch(
                              getPeriodicityByOrg({
                                tipo_busqueda: "empresa__id",
                                filter: parseInt(values.empresa),
                                tipo_busqueda_2: "clasificacion_id",
                                filter_2: parseInt(e.currentTarget.value),
                                tipo_busqueda_3: "anio",
                                filter_3: parseInt(
                                  !edit
                                    ? currentYear
                                    : editItem.list_periodicidad[0].anio
                                ),
                              })
                            );
                            if (e.currentTarget.value !== "") {
                              setIsOrgSelect(true);
                            } else {
                              setIsOrgSelect(false);
                            }
                            handleChange(e);
                          }}
                          disabled={(!edit && _empresa === "") || edit}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar clasificación
                          </option>
                          {dataClasificacion
                            ? dataClasificacion.length > 0 &&
                              dataClasificacion
                                .sort((a, b) =>
                                  a.nombre > b.nombre
                                    ? 1
                                    : b.nombre > a.nombre
                                    ? -1
                                    : 0
                                )
                                .map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.nombre ? item.nombre : ""}
                                  </option>
                                ))
                            : ""}
                        </Form.Control>
                      </Col>
                      {loadingClasificacion || loadingPeriodicity ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                    {touched.clasificacion && errors.clasificacion && (
                      <Col>
                        <small className="text-danger">
                          {errors.clasificacion}
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                {edit && moment(fecha) > moment(editItem.fecha_fin) ? null : (
                  <>
                    <Button
                      className="rounded-pill"
                      disabled={
                        saveLoading ||
                        (!loadingPeriodicity &&
                          !edit &&
                          periodicityError === "" &&
                          !periodicity.id &&
                          isOrgSelect) ||
                        (edit && moment(fecha) > moment(editItem.fecha_fin)) ||
                        loadingOrgs ||
                        loadingPeriodicity ||
                        values.empresa === ""
                      }
                      variant="primary"
                      type="submit"
                    >
                      {saveLoading || loadingPeriodicity ? (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : null}
                      Guardar
                    </Button>
                  </>
                )}
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      <Modal show={showModalCopy} onHide={() => setShowModalCopy(false)}>
        <Formik
          validationSchema={schemaCopy}
          onSubmit={onSubmitCopy}
          initialValues={{
            clasificacion: [],
          }}
        >
          {({
            handleSubmit,
            // handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            // isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  <i className="material-icons">content_copy</i> Copiar
                  plantilla
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formCopyError && (
                  <Alert variant="danger" className="mt-1 mb-2">
                    {formCopyError}
                  </Alert>
                )}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Clasificación
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={loadingClasificacion ? "10" : "12"}>
                        <Multiselect
                          id="clasificacion"
                          name="clasificacion"
                          options={listClasificacion.filter(exists)}
                          value={values.clasificacion}
                          onChange={(selected) => {
                            setFieldValue(
                              "clasificacion",
                              selected.length > 0 ? selected : []
                            );
                          }}
                          isValid={
                            touched.clasificacion && !errors.clasificacion
                          }
                          isInvalid={
                            touched.clasificacion && errors.clasificacion
                          }
                          isDisabled={
                            loadingOrgs ||
                            listClasificacion.filter(exists).length === 0
                          }
                          onBlur={() => handleBlur("clasificacion")}
                        />
                      </Col>
                      {loadingClasificacion ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                    {touched.clasificacion && errors.clasificacion && (
                      <Col>
                        <small className="text-danger">
                          {errors.clasificacion}
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : null}
                  Copiar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default FactorTemplate;
